<template>
  <div class="input-with-btn b lr ac">
    <Input
      :value="code"
      @on-change="change"
      class="input"
      size="large"
      maxlength="5"
      placeholder="输入验证码"
    />
    <Button
      :disabled="disable"
      class="btn customBtn"
      type="primary"
      size="large"
      :loading="loading"
      @click="clickBtn"
      >{{ btnText }}</Button
    >
  </div>
</template>

<script>
export default {
  name: 'inputWithBtn',
  props: ['code', 'placeholder', 'btnText', 'disable', 'onClick', 'loading'],
  model: {
    prop: 'code',
    event: 'verify'
  },
  methods: {
    clickBtn() {
      this.$emit('when-click');
    },
    change(e) {
      this.$emit('verify', e.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-with-btn {
  /deep/ input {
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  /deep/ button {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
